module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./libs/atenea-cms-brand/src/products/product-summary-form/product-summary-form.component.scss
// module id = ./libs/atenea-cms-brand/src/products/product-summary-form/product-summary-form.component.scss
// module chunks = main